import styled, { css } from 'styled-components';

type StepProps = {
  isActive: boolean;
  isLast?: boolean;
  isComplete?: boolean;
};

export const StepContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
`;

export const Step = styled.div<StepProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Alinha o conteúdo à esquerda */
  flex: 1;
  min-height: 76px;
  padding: 0 22px; /* Espaçamento interno para o número e o título */
  gap: 16px; /* Espaço entre o número e o título */
  background: ${({ isActive }) => (isActive ? '#e6f0ff' : '#ffffff')};
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;

  ${({ isActive, isComplete }) =>
    (isActive || isComplete) &&
    css`
      border-top: 2px solid #0b29fb;
      border-bottom: 2px solid #0b29fb;
      border-left: 2px solid #0b29fb;
      border-right: 2px solid #0b29fb;
    `}

  ${({ isComplete }) =>
    isComplete &&
    css`
      background: #0b29fb;
    `}

  ${({ isActive, isComplete }) =>
    (isActive || isComplete) &&
    css`
      border-color: #0b29fb;
    `}

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-right: 1px solid #d9d9d9; /* Mantém a borda do último step */
  }
  &:not(:first-child) {
    border-left: unset;
  }
  &:not(:last-child) {
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    border-right: unset;

    ${({ isActive, isComplete }) =>
      (isActive || isComplete) &&
      css`
        border-top: 2px solid #0b29fb;
        border-bottom: 2px solid #0b29fb;
      `}
  }
`;
export const StepNumber = styled.div<StepProps>`
  min-width: 40px;
  min-height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Mangueira';
  font-weight: 500;
  font-size: 16px;
  color: ${({ isActive }) => (isActive ? '#ffffff' : '#3d3d3d')};
  border: 2px solid #3d3d3d;
  background: ${({ isActive }) => (isActive ? '#0066cc' : '#ffffff')};

  ${({ isActive }) =>
    isActive &&
    css`
      border: 2px solid #0066cc;
    `}

  ${({ isComplete }) =>
    isComplete &&
    css`
      border: 2px solid #ffffff;
    `}
`;

export const StepTitle = styled.div<StepProps>`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 14px;
  color: #3d3d3d;

  ${({ isActive }) =>
    isActive &&
    css`
      font-weight: 700;
    `}

  ${({ isComplete }) =>
    isComplete &&
    css`
      font-weight: 700;
      color: #ffffff;
    `}
`;

export const ImgSeparator = styled.img`
  height: 79px;
  align-self: stretch;
  object-fit: contain;
  margin: 0;
  position: absolute;
  top: -3px;
  right: -12px;
  z-index: 1;
`;
